module.exports = __webpack_public_path__ + "img/reception3.004cfe72.png";